import { createContext, useEffect, useState } from "react";
import { Analytics } from "aws-amplify";
import axios from "axios";
import getNewTokens from "./RefreshTokens";
import countDownTimer from "../components/timeOutCheck";
import { useHistory, useLocation } from "react-router-dom";
import queryString from "query-string";
// import {
//   updateAnonymousUserIdInFullStory,
//   updateUserIdInFullStory,
// } from "../fullStoryConfig";

export const AuthContext = createContext();
// const TIMEOUT_IN_MS = 120_000; // 2 mins for testing timeout
const TIMEOUT_IN_MS = 72_00_000; // 2 hours

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState({});
  const refreshTokens = getNewTokens();
  const userTimer = countDownTimer();
  const location = useLocation();
  const history = useHistory();

  const getRedirectQueryString = function (redirectTo) {
    let qs = { redirectTo };
    return `?${queryString.stringify(qs)}`;
  };
  const onAuthErrored = () => {
    setIsAuthenticated(false);
    const loginBy = localStorage.getItem("loginBy");
    if (loginBy === "sso") {
      history.replace("/logout");
    } else {
      history.replace(`/login${getRedirectQueryString(location.pathname)}`);
    }
    localStorage.clear();
  };

  const timeOutDone = () => {
    history.push(`/timeout`);
  };

  const confirmTimedOut = () => {
    setIsAuthenticated(false);
    setUser({});
    const loginBy = localStorage.getItem("loginBy");
    if (loginBy === "sso") {
      history.replace("/logout");
    } else {
      history.replace("/login");
    }
    localStorage.clear();
  };

  const logout = async () => {
    let accessToken = localStorage.getItem("accessToken");
    localStorage.clear();
    setIsAuthenticated(false);
    setUser({});
    return Promise.all([
      axios({
        method: "post",
        url: "/api/accepttermsandcondition/logout",
        headers: { "x-access-token": `${accessToken}` },
      }),
      Analytics.updateEndpoint({
        userAttributes: {
          uID: ["0"],
        },
      }).catch(error => {
        console.error("Error updating endpoint in Analytics:", error);
      })
      // updateAnonymousUserIdInFullStory()
    ]);
  };

  const changeUser = async (userObj) => {
    if (userObj && userObj.userId) {
      setIsAuthenticated(true);
      setUser(userObj);
      await Analytics.updateEndpoint({
        userAttributes: {
          uID: [userObj.userId],
        },
      }).catch(error => {
        console.error("Error updating endpoint in Analytics:", error);
      });
      // updateUserIdInFullStory(userObj.userId);
    } else {
      logout();
    }
  };

  const getUserDetails = async () => {
    try {
      await refreshTokens();
      let userDetails = await axios({
        method: "get",
        url: "/api/userservice/userdetails",
        headers: { "x-access-token": localStorage.getItem("accessToken") },
      });
      if (userDetails.status === 200) {
        changeUser(userDetails.data);
      }
    } catch (error) {
      //ignoring error related to authentication
    }
  };

  useEffect(() => {
    if (user.userId) {
      getUserDetails();
    }
    userTimer(TIMEOUT_IN_MS, timeOutDone);
    return () => {
      // Anything in here is fired on component unmount.
      userTimer.stopTimer();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const makeAuthenticatedApiCall = async (method, url, data) => {
    try {
      try {
        let accessToken;
        if (!localStorage.getItem("accessToken")) {
          const searchParams = new URLSearchParams(window.location.search);
          accessToken = searchParams.get("accessToken");
          if (!accessToken) {
            let error = new Error();
            error.forceNewAccessToken = true;
            throw error;
          }
        } else {
          const searchParams = new URLSearchParams(window.location.search);
          accessToken = searchParams.get("accessToken");
        }
        userTimer.setServerAccessed();
        let result = await axios({
          headers: {
            "x-access-token":
              accessToken || localStorage.getItem("accessToken"),
          },
          method,
          url,
          data,
        });
        if (result && result.status === 200) {
          if (!isAuthenticated) {
            setIsAuthenticated(true);
          }
          return result;
        } else {
          onAuthErrored();
        }
      } catch (error) {
        if (
          (error.response && error.response.status === 401) ||
          error.forceNewAccessToken
        ) {
          if (!localStorage.getItem("refreshToken")) {
            throw new Error(
              "can't call authenticated API without refresh token"
            );
          }
          await refreshTokens();
          let result = await axios({
            headers: {
              "x-access-token": localStorage.getItem("accessToken"),
            },
            method,
            url,
            data,
          });
          if (result && result.status === 200) {
            if (!isAuthenticated) {
              setIsAuthenticated(true);
            }
            return result;
          } else {
            onAuthErrored();
          }
        } else {
          return error.response;
        }
        throw error;
      }
    } catch (ex) {
      console.log("ERROR:", ex);
      onAuthErrored();
    }
    return null;
  };

  return (
    <AuthContext.Provider
      value={{
        isAuthenticated,
        user,
        logout,
        confirmTimedOut,
        changeUser,
        makeAuthenticatedApiCall,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
